import React, { } from 'react';
import { Card, Col, Row, } from 'antd';

import cragknoll from '../myContent/cragknoll.png';
import bookImage from '../myContent/TheLegendsOfCragknoll.png';
import gamebox3dImage from '../myContent/3dGameBoxSmall.png';
import eatAllDonuts from '../myContent/EatAllDonuts.png';

import warscholarAndroid from '../myContent/WarscholarAndroid.png';

import '../App.css';




const HomePage: React.FC = () => {


  return (
    <div className="App">
      <header className="App-header">

        Welcome!

        <img src={cragknoll} alt="cragknoll" className='width400 padThatBottom myLogo' />

        <Card className='width395 marginBig' >
          <Row>
            <Col span={24}>
              <a
                className="App-link"
                href="https://www.amazon.com/Legends-Cragknoll-Reece-Hewitt-ebook/dp/B09BBSP3SS"
                target="_blank"
                rel="noopener noreferrer">
                The Legends of Cragknoll book/ebook
              </a>
            </Col>
            <Col span={24}>
              <img src={bookImage} alt="bookImage" className='height180' />
            </Col>
          </Row>
        </Card>

        <Card className='width395 marginBig' >
          <Row>
            <Col span={24}>
              <a
                className="App-link"
                href="/warscholar"
                rel="noopener noreferrer">
                WarScholar in-browser
              </a>
            </Col>
            <Col span={24}>
              <img src={warscholarAndroid} alt="warscholarAndroid" className='width160' />
            </Col>
          </Row>
        </Card>



        <Card className='width395 marginBig' >
          <Row>
            <Col span={24}>
              <a
                className="App-link"
                href="/itchgames"
                rel="noopener noreferrer">
                Itch.io Games
              </a>
            </Col>
            <Col span={24}>
              <img src={eatAllDonuts} alt="eatAllDonuts" className='width160' />
            </Col>
          </Row>
        </Card>


        <Card className='width395 marginBig' >
          <Row>
            <Col span={24}>
              <a
                className="App-link"
                href="/androidgames"
                rel="noopener noreferrer">
                Android Games
              </a>
            </Col>
            <Col span={24}>
              <img src={warscholarAndroid} alt="warscholarAndroid" className='width160' />
            </Col>
          </Row>
        </Card>

        <Card className='width395 marginBig' >
          <Row>
            <Col span={24}>
              <a
                className="App-link"
                href="/boardgame"
                rel="noopener noreferrer">
                Boardgame
              </a>
            </Col>
            <Col span={24}>
              <img src={gamebox3dImage} alt="gamebox3dImage" className='width160' />
            </Col>
          </Row>
        </Card>

      </header>
    </div>
  );
}

export default HomePage;
